"use client";
import { useAuthContext } from "@/context/auth-context";
import MainNavbar from "@/components/navbar/main-navbar";
import LoginNavbar from "@/components/navbar/login-navbar";
import { useSession } from "next-auth/react";
import SFMainNavbar from "@/components/navbar/sf-main-navbar";

const Navigation = () => {
  const { isLoggedIn } = useAuthContext();

  const { data: salesforceSession } = useSession();

  const navbarToShow =
    isLoggedIn && salesforceSession ? <SFMainNavbar /> : <MainNavbar />;

  return <>{!isLoggedIn ? <LoginNavbar /> : navbarToShow}</>;
};

export default Navigation;
